import React from 'react';
import {
  StatusWithDueDate
} from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import { StatusPill } from '../status-pill/StatusPill.component';

export type TotalsStatusProps = {
  completedGoal: number;
  completed: number;
  total: number;
}
export const TotalsStatus = (props: TotalsStatusProps): JSX.Element => {

  if (props.completed >= props.completedGoal) {
    return (
      <StatusPill status={StatusWithDueDate.COMPLETED_PASSED}>
        {props.completed}/{props.total}
      </StatusPill>
    );
  }

  return (
    <StatusPill status={props.completed > 0 ? StatusWithDueDate.IN_PROGRESS : StatusWithDueDate.NOT_STARTED}>
      {props.completed}/{props.total}
    </StatusPill>
  );
};
